<template>
  <section>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5">
        <v-text-field
          filled
          class="no-before"
          dense
          hide-details
          label="Total de la caisse"
          suffix="$"
          :value="caisse"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-icon small>fa-minus</v-icon>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5">
        <v-text-field
          filled
          dense
          class="no-before"
          hide-details
          label="Devrait être"
          :value="' '"
          readonly
          suffix="$"
          :prefix="
            `${lastTillCash} + ${payment} - ${directPurchases} = ${shouldBe}`
          "
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" no-gutters>
      <v-icon small>fa-equals</v-icon>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5">
        <v-text-field
          dark
          :background-color="difference >= 0 ? 'success' : 'error'"
          filled
          class="no-before"
          hide-details
          suffix="$"
          :label="difference >= 0 ? 'Surplus' : 'Écart'"
          :value="difference"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import round10 from "round10";
import { api } from "@/api";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "TillReport",
  props: {
    ecart: {
      type: Number,
      required: true
    },
    caisse: {
      type: Number,
      required: true
    },
    payment: {
      type: Number,
      required: true
    },
    directPurchases: {
      type: Number,
      required: true
    },
    dates: {
      type: Array,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  created() {
    this.getDefaultCaisse();
  },
  data() {
    return {
      defaultTillCash: 350,
      lastTillCash: 350
    };
  },
  computed: {
    ...mapGetters(["getTills", "getAuthHeader", "getStoreId"]),
    shouldBe() {
      return this.lastTillCash + this.payment - this.directPurchases;
    },
    difference() {
      const ecart = round10.round10(this.caisse - this.shouldBe, -2);
      this.$emit("update:ecart", ecart);
      return ecart;
    },
    sortedDates() {
      return this.dates.map(d => moment(d)).sort((a, b) => a.diff(b));
    },
    lastTill() {
      if (this.sortedDates[0]) {
        return this.getTills
          ? this.getTills.filter(x =>
              moment(x.end_date).isSame(
                moment(this.sortedDates[0]).subtract(1, "days")
              )
            ).length > 0
            ? this.getTills.filter(x =>
                moment(x.end_date).isSame(
                  moment(this.sortedDates[0]).subtract(1, "days")
                )
              )[0]
            : undefined
          : undefined;
      } else {
        return undefined;
      }
    }
  },
  methods: {
    async getFCaisse() {
      if (this.lastTill) {
        try {
          this.loading = true;
          const res = await api.retrieveFondCaisse(this.lastTill.id);
          this.lastTillCash = this.calculateTotal(res);
        } finally {
          this.loading = false;
        }
      } else {
        this.lastTillCash = this.defaultTillCash;
      }
    },
    calculateTotal(fCaisse) {
      let total =
        fCaisse.argent_5cent * 0.05 +
        fCaisse.argent_10cent * 0.1 +
        fCaisse.argent_25cent * 0.25 +
        fCaisse.argent_1dollar * 1 +
        fCaisse.argent_2dollar * 2 +
        fCaisse.argent_5dollar * 5 +
        fCaisse.argent_10dollar * 10 +
        fCaisse.argent_20dollar * 20 +
        fCaisse.argent_50dollar * 50 +
        fCaisse.argent_100dollar * 100 +
        fCaisse.rouleaux_5cent * 2 +
        fCaisse.rouleaux_10cent * 5 +
        fCaisse.rouleaux_25cent * 10 +
        fCaisse.rouleaux_1dollar * 25 +
        fCaisse.rouleaux_2dollar * 50;
      if (
        Number.isNaN(total) ||
        total === null ||
        typeof total === "undefined"
      ) {
        total = this.defaultTillCash;
      }
      return total;
    },
    async getDefaultCaisse() {
      try {
        this.loading = true;
        const res = await api.getDefaultFondCaisse();
        if (res && res !== "") {
          this.defaultTillCash = this.calculateTotal(res);
        } else {
          this.defaultTillCash = 350;
        }
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    lastTill: {
      immediate: true,
      handler: "getFCaisse"
    },
    dates: {
      handler: "getFCaisse"
    }
  }
};
</script>

<style lang="scss" scoped></style>
